var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePopupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_498_3543)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 48,
    fill: "#FFEDED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9975 39.1361L38.998 39.1342C39.2252 38.2511 40.254 37.8663 41.0066 38.3893C41.1471 38.4926 41.2818 38.6173 41.4128 38.7483L55.4773 52.8199C55.5289 52.8715 55.5719 52.9342 55.6289 53.0174C55.6472 53.044 55.6669 53.0728 55.6889 53.1041C55.7563 53.2 55.8539 53.2537 55.946 53.2762C56.1245 53.3199 56.3152 53.2408 56.4036 53.0694C56.411 53.0551 56.4179 53.0416 56.4244 53.0289C56.4749 52.9304 56.5013 52.8789 56.5394 52.8408L56.5398 52.8404C59.3591 50.0071 62.1857 47.1779 65.0131 44.3478C66.8978 42.4613 68.7829 40.5744 70.6666 38.6856C71.0828 38.2693 71.5083 38.0616 72.0352 38.1892L72.036 38.1894C72.9932 38.4178 73.3684 39.5181 72.7628 40.2821L72.7605 40.285C72.6886 40.3786 72.6073 40.4586 72.5148 40.5496C72.49 40.5739 72.4645 40.5991 72.4381 40.6255L72.6149 40.8022L72.4381 40.6255L72.4355 40.6281C67.7586 45.3074 63.0818 49.9865 58.3946 54.6656L58.3944 54.6658C58.3779 54.6824 58.3594 54.6995 58.3377 54.7184C58.1735 54.8618 58.1035 55.055 58.125 55.2497C58.1454 55.4334 58.2439 55.5983 58.3776 55.7216C60.736 58.076 63.0944 60.433 65.4528 62.79L65.4529 62.7901C67.8125 65.1483 70.1722 67.5065 72.5319 69.8622C72.9482 70.2788 73.1543 70.7029 73.0187 71.2282L73.0179 71.2317C72.7895 72.1723 71.7065 72.5554 70.9445 71.9788C70.8143 71.8762 70.7 71.7624 70.5796 71.6319L70.5797 71.6318L70.5727 71.6247L63.556 64.6045L56.5394 57.5844C56.2926 57.3374 55.8645 57.2129 55.5379 57.5178C55.5204 57.5341 55.5033 57.55 55.4859 57.5657L55.4857 57.5655L55.4768 57.5745C51.7102 61.368 47.9369 65.1415 44.162 68.9166C43.2179 69.8608 42.2737 70.8051 41.3295 71.7498C40.9168 72.1626 40.4907 72.3647 39.9494 72.2357C39.028 72.0162 38.6372 70.9597 39.197 70.1984L39.199 70.1955C39.2622 70.107 39.3334 70.0333 39.4182 69.9456C39.4561 69.9064 39.4966 69.8644 39.5405 69.817L53.5943 55.7561C53.9068 55.4871 53.9755 54.998 53.6228 54.6913L53.4587 54.8799L53.6228 54.6913C53.6032 54.6743 53.5845 54.6577 53.5663 54.641L39.4745 40.5421C39.2551 40.3226 39.1014 40.1075 39.0192 39.8835C38.9388 39.6642 38.9215 39.4223 38.9975 39.1361Z",
    fill: "#E24950",
    stroke: "#FFEDED",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_498_3543",
    x: 0,
    y: 0,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_498_3543"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.829167 0 0 0 0 0.829167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_498_3543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_498_3543",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePopupIcon);
export default __webpack_public_path__ + "static/media/delete-popup-icon.dabe6c5b662f1c41ff4dd5186c4d7cda.svg";
export { ForwardRef as ReactComponent };